import React from "react";
import { Symbol } from "@evergis/react";
import { MaskedSymbols } from "react-sgis/symbols/SymbolRenderer/defaultSymbols";
import { Offset } from "@evergis/sgis/es/baseTypes";

import { ReactLabelSymbol } from "../ReactLabelSymbol";
import { ClosableTooltipLabel, CloseIcon, TooltipLabel, Text } from "./styled";

export const defaultOffset: Offset = [8, -16];

type LabelSymbolConfig = {
  offset?: Offset;
};
// TODO export from react
type SymbolRenderProps = Parameters<typeof Symbol>[0];

const labelSymbolComponents = {
  pinSymbol: (props: Partial<SymbolRenderProps>) => () => <Symbol symbol={MaskedSymbols.pin} {...props} />,
  tooltipSymbol:
    ({ maxWidth }: Partial<{ maxWidth: number }>) =>
    ({ content }) =>
      <TooltipLabel maxWidth={maxWidth}>{content}</TooltipLabel>,
  tooltipClosableSymbol:
    ({ onClose }: Partial<{ onClose: VoidFunction }>) =>
    ({ content }) =>
      (
        <ClosableTooltipLabel>
          {content}
          <CloseIcon
            kind={"close"}
            onClick={e => {
              e?.stopPropagation();
              onClose();
            }}
          />
        </ClosableTooltipLabel>
      ),
  textSymbol:
    () =>
    ({ content }) =>
      <Text>{content}</Text>,
};

type LabelSymbolsCollection = typeof labelSymbolComponents;

export const createLabelSymbol = <S extends keyof LabelSymbolsCollection>(
  symbolName: S,
  config?: (Parameters<LabelSymbolsCollection[S]>[0] | Record<string, unknown>) & LabelSymbolConfig,
) => {
  const { offset = defaultOffset, ...props } = config || {};

  return new ReactLabelSymbol({
    offset,
    component: labelSymbolComponents[symbolName](props),
  });
};
